var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveLibrary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_book-square",
    "data-name": "vuesax/bold/book-square",
    transform: "translate(-492 -190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(492 190)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M14.19,0H5.81C2.17,0,0,2.17,0,5.81v8.37C0,17.83,2.17,20,5.81,20h8.37c3.64,0,5.81-2.17,5.81-5.81V5.81C20,2.17,17.83,0,14.19,0ZM9.5,15.25a.5.5,0,0,1-.69.46,16.45,16.45,0,0,0-3.89-1.14l-.19-.02a1.317,1.317,0,0,1-1.11-1.27V5.58A1.26,1.26,0,0,1,5,4.3,11.988,11.988,0,0,1,9.26,5.66a.486.486,0,0,1,.24.43Zm6.88-1.98a1.317,1.317,0,0,1-1.11,1.27l-.21.02a17.4,17.4,0,0,0-3.87,1.13.5.5,0,0,1-.69-.46V6.08a.5.5,0,0,1,.25-.44,12.19,12.19,0,0,1,4.2-1.34h.04a1.387,1.387,0,0,1,1.39,1.39Z",
    transform: "translate(494 192)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLibrary);
export default __webpack_public_path__ + "static/media/active_library.c24a3a37c54cede535e235c07c5ef120.svg";
export { ForwardRef as ReactComponent };